// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"12014951","297":"b73ad433","643":"b53b6ab6"}[chunkId] + ".chunk.js";
};